import colors from 'vuetify/es5/util/colors'

export default class Color {
  // Generic colors
  static get black () { return '#000000' }

  static get white () { return '#ffffff' }

  static get offlineGray () { return colors.blueGrey.lighten2 }

  static get onlineWhite () { return '#ffffff' }

  static get red () { return '#ff0000' }

  // Theme colors (t)
  static get tBlueDark () { return '#1a237e' }

  static get tBlue () { return '#3f51b5' }

  static get tYellow () { return '#ffaa00' }

  // Signals colors (sig)
  static get sigBack () { return colors.grey.darken3 }

  static get sigRed () { return colors.red.base }
}
